var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledHeartLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8737 3.66675C4.08932 3.66675 1.83203 5.92404 1.83203 8.70842C1.83203 13.7501 7.79037 18.3334 10.9987 19.3995C14.207 18.3334 20.1654 13.7501 20.1654 8.70842C20.1654 5.92404 17.9081 3.66675 15.1237 3.66675C13.4187 3.66675 11.9108 4.51329 10.9987 5.809C10.5337 5.14688 9.91609 4.60652 9.19807 4.23363C8.48005 3.86074 7.68277 3.66629 6.8737 3.66675Z",
    fill: "#034A73",
    stroke: "#034A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeartLarge);
export default __webpack_public_path__ + "static/media/filled_heart_large.c55a209da37dafa59023b2b9a618730a.svg";
export { ForwardRef as ReactComponent };